import axios from 'axios';

// Detectar automáticamente la URL de la API
// En producción, SIEMPRE usar URL relativa para evitar problemas de CORS y routing
const getApiUrl = () => {
  // En producción (mismo servidor), SIEMPRE usar URL relativa
  // Esto funciona porque el frontend y backend están en el mismo dominio
  if (process.env.NODE_ENV === 'production') {
    // Forzar URL relativa, ignorar REACT_APP_API_URL si existe
    return '/api';
  }
  
  // En desarrollo, usar localhost
  // Si hay una variable de entorno definida, usarla (solo en desarrollo)
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  return 'http://localhost:8000/api';
};

const API_URL = getApiUrl();

// Log de la URL de la API (solo en desarrollo o para debugging)
if (process.env.NODE_ENV === 'production') {
  console.log('🔗 API URL configurada:', API_URL);
  console.log('🔗 NODE_ENV:', process.env.NODE_ENV);
  console.log('🔗 REACT_APP_API_URL:', process.env.REACT_APP_API_URL);
}

// Crear instancia de axios
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Configurar interceptor para incluir el token en todas las peticiones
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // No establecer Content-Type si es FormData (el navegador lo hará automáticamente)
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    
    // Log de la URL completa que se está usando (solo en producción para debugging)
    if (process.env.NODE_ENV === 'production') {
      const fullUrl = config.baseURL + config.url;
      console.log('🔗 Petición API:', {
        method: config.method?.toUpperCase(),
        url: config.url,
        baseURL: config.baseURL,
        fullURL: fullUrl
      });
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para manejar errores de autenticación
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Log del error para debugging en producción
    if (process.env.NODE_ENV === 'production') {
      console.error('API Error:', {
        url: error.config?.url,
        status: error.response?.status,
        message: error.message,
        response: error.response?.data
      });
    }
    
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
